import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { cameraSteps } from '../../shared/constants/cameraSteps';

export interface ChildProps {
  onClick: (modalState: boolean | undefined) => void;
}

export default function TextMobileStepper(props: ChildProps) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = cameraSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCloseModal = () => {
    props.onClick(false);
  };

  return (
    <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
      <Box sx={{ height: '340px', maxWidth: 400, width: '100%', margin: '0 auto', display: 'table' }}>
        <br />
        <img src={cameraSteps[activeStep].label} alt="" width="180px" />
        <br />
        <br />
        <span style={{ fontFamily: 'iranSans', fontSize: '15px' }}>{cameraSteps[activeStep].description}</span>
      </Box>
      <MobileStepper
        variant="dots"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          activeStep !== maxSteps - 1 ? (
            <Button
              variant="contained"
              size="medium"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
              style={{ fontFamily: 'iranSans', fontSize: '13px' }}
            >
              بعدی
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowLeft />}
            </Button>
          ) : (
            <Button
              variant="contained"
              size="medium"
              onClick={handleCloseModal}
              style={{ fontFamily: 'iranSans', fontSize: '13px' }}
            >
              فهمیدم
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowLeft />}
            </Button>
          )
        }
        backButton={
          activeStep !== 0 ? (
            <Button
              variant="outlined"
              size="medium"
              onClick={handleBack}
              disabled={activeStep === 0}
              style={{ fontFamily: 'iranSans', fontSize: '13px' }}
            >
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowRight />}
              قبلی
            </Button>
          ) : (
            <Button
              variant="outlined"
              size="medium"
              onClick={handleCloseModal}
              style={{ fontFamily: 'iranSans', fontSize: '13px' }}
            >
              بلدم
            </Button>
          )
        }
      />
    </Box>
  );
}
